import { useHistory, useLocation } from 'react-router-dom';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import { CustomizedTooltip } from 'components/common';

export const AddTaskWrapper = () => {
    const { pathname, search } = useLocation();
    const history = useHistory();

    const handleAddTask = () => {
        history.push(`${pathname}/card-newCard${search}`);
    };

    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Top}
            tooltipContent={`Add Card`}
            triggerElement={
                <Button variant={'primary'} circle={true} onClick={handleAddTask}>
                    <MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />
                </Button>
            }
        />
    );
};
